<template>
  <div
    :class="{
      [$style.calculationComponent]: true,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone
    }"
  >
    <div :class="$style.imgBox">
      <img
        src="@/assets/images/certification-icon.svg"
        alt="certification icon"
      />
    </div>
    <h1 :class="$style.heading">Ihr Angebot liegt bereit!</h1>
    <div :class="$style.list">
      <li :class="$style.listItem">
        <span :class="$style.iconBox"
          ><img src="@/assets/images/checked.svg" alt="checked icon"/></span
        >Von Immobilienexperten erstellt
      </li>
      <li :class="$style.listItem">
        <span :class="$style.iconBox"
          ><img src="@/assets/images/checked.svg" alt="checked icon"/></span
        >100 % kostenfrei und unverbindlich
      </li>
      <li :class="$style.listItem">
        <span :class="$style.iconBox"
          ><img src="@/assets/images/checked.svg" alt="checked icon"/></span
        >Inklusive Immobilienbewertung
      </li>
      <li :class="$style.listItem">
        <span :class="$style.iconBox"
          ><img src="@/assets/images/checked.svg" alt="checked icon"/></span
        >Schneller Versand garantiert
      </li>
      <li :class="$style.listItem">
        <span :class="$style.iconBox"
          ><img src="@/assets/images/checked.svg" alt="checked icon"/></span
        >Kein Durchführungsentgelt: bis zu 6,5 % sparen
      </li>
    </div>
    <img src="@/assets/images/wohin-sollen.svg" alt="" :class="$style.gif" />
  </div>
</template>

<script>
import store from '@/store'

export default {
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    el() {
      return store.state.el
    }
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';
@import '@/scss/animations.scss';

.calculationComponent {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  max-width: 430px;
  color: $color_font_2;
  text-align: left;
  line-height: 1.2;
}
.imgBox {
  height: 104px;
  width: 104px;
  margin-bottom: 38px;
  img {
    height: 100%;
  }
}
.heading {
  font-size: 34px;
  font-weight: 400;
  margin-bottom: 53px;
  line-height: 1.2;
}

.list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 450px;
  line-height: 1.2;
  font-weight: 500;
}

.listItem {
  .iconBox {
    width: 30px;
    height: 30px;
    margin-right: 17px;
    img: {
      height: 100%;
    }
  }

  display: flex;
  align-items: center;
  margin-bottom: 21px;
  font-size: 18px;
  width: 100%;
  font-weight: 500;
}

.gif {
  position: absolute;
  bottom: 16.9px;
  right: -5px;
}

// // note: port
// .port {
//   .text {
//     padding-bottom: 0px;
//   }
// }

// note: phone
.phone {
  &.calculationComponent {
    max-width: 100%;
    width: 100%;
    font-weight: 500;
  }
  .imgBox {
    display: none;
  }
  .heading {
    margin-bottom: 24px;
    font-size: 26px;
    font-weight: 500;
    text-align: center;
    width: 100%;
  }
  .list {
    width: 100%;
    margin-bottom: 90px;
  }
  .gif {
    position: absolute;
    bottom: 16.9px;
    right: 50%;
    transform: translateX(50%);
  }
}
</style>
